export default __webpack_public_path__ + "static/media/README.f0968ec5.md";